/**
 * Mobile PWA Batch B3 — allowed route policy for smartphones.
 *
 * Policy: on smartphone viewports (≤ 767px), the ONLY clinical surfaces
 * exposed are Ask the Bench and Case Intake. Account/security and auth
 * flow-gate pages are also allowed. Everything else is desktop-only.
 *
 * Desktop routes are NOT removed or disabled — direct attempts to open
 * a desktop-only route on a smartphone are redirected to `/quick-assist`
 * ("Ask the Bench" — the mobile home) by <MobileRouteGuard/>.
 *
 * Tablets and desktops (>= 768px) see the full app unchanged.
 */

// Mobile home — Ask the Bench.
export const MOBILE_HOME = "/quick-assist";

/**
 * Exact-match paths allowed on smartphone.
 * Auth / consent / gate pages are always allowed so users can complete
 * onboarding + 2FA + BAA + disclaimer on their phone.
 */
const MOBILE_ALLOWED_EXACT = new Set([
  "/",                       // landing
  "/login",
  "/signup",
  "/register",
  "/sign-in",
  "/sign-up",
  "/set-password",
  "/accept-baa",
  "/enroll-2fa",
  "/baa",
  "/terms",
  "/disclaimer",
  "/legal/disclaimer",
  "/quick-assist",           // Ask the Bench (mobile home)
  "/quick-assessment",       // Case Intake — list
  "/quick-assessment/new",   // Case Intake — new
  "/account",                // Account / ARIA / 2FA settings
  "/payment-success",
]);

/**
 * Prefix-based allow list (dynamic segments). Any path starting with one
 * of these prefixes is allowed on smartphone.
 */
const MOBILE_ALLOWED_PREFIXES = [
  "/quick-assessment/",      // detail views
  "/collab/portal/",         // public specialist portal (token-authenticated)
  "/patient-portal/",        // public patient portal (token-authenticated)
];

export function isMobileAllowedPath(pathname) {
  if (!pathname) return false;
  const clean = pathname.replace(/\/+$/, "") || "/";
  if (MOBILE_ALLOWED_EXACT.has(clean)) return true;
  return MOBILE_ALLOWED_PREFIXES.some((p) => pathname.startsWith(p));
}
